import styled from "@emotion/styled";

import {
    reactUiModalLeftPadding,
    reactUiModalRightPadding,
} from "../../../../Internals/ThemeProvider/ReactUiModalPaddings";
import { sizeToken } from "../../../../Internals/ThemeProvider/CandyTheme/ThemeBuilder/ICandyTheme";
import { theme } from "../../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const NotFoundContainer = styled.div({
    paddingLeft: reactUiModalLeftPadding,
    paddingRight: reactUiModalRightPadding,
    paddingTop: sizeToken(3),
});

export const Title = styled.div({
    marginBottom: sizeToken(1),
});

export const HeaderContainer = styled.div({
    outline: 0,
});

// Скрывает дефолтный серый разделитель хэдера при скролле
// Через theme не скрыть, убирается разделитель у футера
export const PicklistHeaderWrapper = styled.div({
    "[data-tid='ModalHeader__root'] + div": {
        display: "none",
    },
});

export const BodyContainer = styled.div(props => ({
    ...theme(props).typography.primary.css(),
    minHeight: 200,
    outline: 0,
}));

export const PikedCounter = styled.div({
    display: "flex",
    justifyContent: "end",
    alignItems: "center",
});

export const WIDTH_MODAL = 750;
export const WIDTH_CONTROL_IN_HEADER = 680;
